import axios from 'axios';
import '../helpers/api_helper';
import { api } from '../config';

const BASE = api.API_URL;

export const getFinanzasKpis = (empresaId, year) =>
    axios.get(`${BASE}/finanzas/kpis`, { params: { empresa_id: empresaId, year } });

export const getFinanzasEvolucion = (empresaId, year) =>
    axios.get(`${BASE}/finanzas/evolucion`, { params: { empresa_id: empresaId, year } });

export const getFinanzasGastosHolded = (empresaId, year) =>
    axios.get(`${BASE}/finanzas/gastos-holded`, { params: { empresa_id: empresaId, year } });

export const getFinanzasSaldos = (empresaId) =>
    axios.get(`${BASE}/finanzas/saldos`, { params: { empresa_id: empresaId } });

export const getFinanzasFacturasPendientes = (empresaId, filtroParcial) =>
    axios.get(`${BASE}/finanzas/facturas-pendientes`, {
        params: {
            empresa_id: empresaId,
            date_from: filtroParcial?.from,
            date_to: filtroParcial?.to,
        },
    });

export const getFinanzasParciales = (empresaId, filtroParcial) =>
    axios.get(`${BASE}/finanzas/parciales`, {
        params: {
            empresa_id: empresaId,
            periodo: filtroParcial?.preset,
            date_from: filtroParcial?.from,
            date_to: filtroParcial?.to,
        }
    });

export const getFinanzasPaisesAnual = (empresaId, year, limit = 10) =>
    axios.get(`${BASE}/finanzas/paises-anual`, {
        params: { empresa_id: empresaId, year, limit }
    });

export const getFinanzasPaisesParcial = (empresaId, filtroParcial, limit = 5) =>
    axios.get(`${BASE}/finanzas/paises-parcial`, {
        params: {
            empresa_id: empresaId,
            periodo: filtroParcial?.preset,
            date_from: filtroParcial?.from,
            date_to: filtroParcial?.to,
            limit,
        }
    });

export const getFinanzasClientesAnual = (empresaId, year, limit = 10) =>
    axios.get(`${BASE}/finanzas/clientes-anual`, {
        params: { empresa_id: empresaId, year, limit }
    });

export const getFinanzasClientesParcial = (empresaId, filtroParcial, limit = 5) =>
    axios.get(`${BASE}/finanzas/clientes-parcial`, {
        params: {
            empresa_id: empresaId,
            periodo: filtroParcial?.preset,
            date_from: filtroParcial?.from,
            date_to: filtroParcial?.to,
            limit,
        }
    });

export const getFinanzasAgingCobros = (empresaId) =>
    axios.get(`${BASE}/finanzas/aging-cobros`, {
        params: { empresa_id: empresaId }
    });

export const getFinanzasDso = (empresaId) =>
    axios.get(`${BASE}/finanzas/dso`, {
        params: { empresa_id: empresaId }
    });

export const getFinanzasTicketMedioAnual = (empresaId, year) =>
    axios.get(`${BASE}/finanzas/ticket-medio-anual`, {
        params: { empresa_id: empresaId, year }
    });

export const getFinanzasTicketMedioParcial = (empresaId, filtroParcial) =>
    axios.get(`${BASE}/finanzas/ticket-medio-parcial`, {
        params: {
            empresa_id: empresaId,
            periodo: filtroParcial?.preset,
            date_from: filtroParcial?.from,
            date_to: filtroParcial?.to,
        }
    });

export const getFinanzasEficiencia = (empresaId, year) =>
    axios.get(`${BASE}/finanzas/eficiencia`, {
        params: { empresa_id: empresaId, year }
    });
